import {IAuthenticatedUserState, initialAuthenticatedUserState} from "../../state/security/authenticated-user.state";
import {AuthenticatedUserActions, EAuthenticatedUserActions} from "../../actions/security/authenticated-user.actions";
import {emptyParty} from "@retail-data-factory/rdf-angular-types-api";


export const authenticatedUserReducers = (
  state = initialAuthenticatedUserState,
  action: AuthenticatedUserActions
):IAuthenticatedUserState =>{
  switch (action.type) {
    case EAuthenticatedUserActions.LoadAuthenticatedUser:
      return {
        ...state
      };

    case EAuthenticatedUserActions.LoadAuthenticatedUserSuccess:
      return {
        ...state,
        data: action.payload,
        isLoaded: true
      };

    case EAuthenticatedUserActions.LoadAuthenticatedUserFailure:
      return {
        ...state,
        data: initialAuthenticatedUserState.data,
        isLoaded: false
      };

    case EAuthenticatedUserActions.LoadSelectedPartyProfile:
      return {
        ...state
      };
    case EAuthenticatedUserActions.LoadSelectedPartyProfileSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          id: state.data.id,
          email: state.data.email,
          login: state.data.login,
          userProfile: state.data.userProfile,
          selectedPartyId: state.data.selectedPartyId,
          availableParty: [action.payload],//state.data.availableParty,
          selectedPartyProfile: action.payload
        },
        isLoaded: true
      };
    case EAuthenticatedUserActions.LoadSelectedPartyProfileFailure:
      return {
        ...state,
        data: {
          id: state.data.id,
          email: state.data.email,
          login: state.data.login,
          userType: state.data.userType,
          userProfile: state.data.userProfile,
          selectedPartyId: state.data.selectedPartyId,
          availableParty: state.data.availableParty,
          selectedPartyProfile: {
            ...emptyParty
          }
        },
        isLoaded: state.isLoaded
      };

    case EAuthenticatedUserActions.SetUserEmail:
      return {
        ...state,
        data: {
          ...state.data,
          id: state.data.id,
          email: action.payload,
          login: state.data.login,
          userProfile: state.data.userProfile,
          selectedPartyId: state.data.selectedPartyId,
          availableParty: state.data.availableParty,
          selectedPartyProfile: state.data.selectedPartyProfile,
        },
        isLoaded: state.isLoaded
      };

    default:
      return state;
  }
};
